import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { Toast, ToastType } from './toast.model'

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toasts$ = new BehaviorSubject<Toast[]>([])

  get toastChanges() {
    return this.toasts$.asObservable()
  }

  success(message: string, duration = 3000) {
    this.show(message, 'success', duration)
  }

  error(message: string, duration = 3000) {
    this.show(message, 'error', duration)
  }

  warning(message: string, duration = 3000) {
    this.show(message, 'warning', duration)
  }

  remove(id: string) {
    this.toasts$.next(this.toasts$.value.filter((t) => t.id !== id))
  }

  private show(message: string, type: ToastType, duration: number) {
    const toast: Toast = {
      id: crypto.randomUUID(),
      message,
      type,
      duration,
    }

    this.toasts$.next([...this.toasts$.value, toast])

    setTimeout(() => this.remove(toast.id), duration)
  }
}
